// extracted by mini-css-extract-plugin
export default {"backgroundGrad":"LandingPage_backgroundGrad__2qGW9"};